import React from "react";
import SEO from "../components/SEO";
import { motion } from "framer-motion";

const Gallery = () => {
  const doodleBg =
    "https://res.cloudinary.com/dze8favft/image/upload/v1755511550/website%20images/Bg/doodle_bg_cpidbb.png";

  const galleryItems = [
    {
      id: 1,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143424/1_eswobc.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143439/16_hglgx2.jpg",
    },
    {
      id: 2,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143425/2_hqk1rl.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143420/17_aizpqi.jpg",
    },
    {
      id: 3,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143416/3_jppu6g.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143420/18_jgcjhf.jpg",
    },
    {
      id: 4,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143416/4_t1vwzm.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143421/19_floa48.jpg",
    },
    {
      id: 5,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143431/5_vjycoi.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143423/20_ww5qor.jpg",
    },
    {
      id: 6,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143416/6_fjepfb.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143432/21_xxetgd.jpg",
    },
    {
      id: 7,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143418/7_ti9ahl.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143431/22_fytath.jpg",
    },
    {
      id: 8,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143419/8_as9lns.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143422/23_u6ym7o.jpg",
    },
    {
      id: 9,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143418/9_iz4c1m.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143424/24_zaaahi.jpg",
    },
    {
      id: 10,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143419/10_br2luu.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143447/25_jchsen.jpg",
    },
    {
      id: 11,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143428/11_mrzrek.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143436/26_mdf62h.jpg",
    },
    {
      id: 12,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143429/12_rlmjgj.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143440/27_phszbt.jpg",
    },
    {
      id: 13,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143431/13_dm4pqr.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143424/28_whxhbm.jpg",
    },
    {
      id: 14,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143442/14_m3xlaw.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143434/29_b9tsyk.jpg",
    },
    {
      id: 15,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143434/15_wbhknw.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765143435/30_r54dsb.jpg",
    },

    {
      id: 16,
      frontImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765912404/got_lliz7i.jpg",
      backImage:
        "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765912420/CC4B0715_o3ha7z.jpg",
    },
  ];

  return (
    <div className="min-h-screen relative">
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Caveat+Brush&display=swap');
          .caveat-brush-font {
            font-family: 'Caveat Brush', cursive;
            font-weight: 400;
            text-transform: none;
          }
          .gradient-line {
            width: 100%;
            height: 5px;
            border-radius: 5px;
            background: linear-gradient(to right, #33bfed, #5fcfe5, #ffcc00);
            margin-top: 8px;
            margin-bottom: 15px;
          }
        `}
      </style>

      {/* SEO */}
      <SEO
        title="School Gallery"
        description="Gallery of school memories"
        keywords="STVMHSS Gallery"
        canonicalPath="/gallery"
      />

      {/* Hero Section */}
      <div
        className="relative text-white py-20 sm:py-28 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0.6)), url(https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_1800/v1757446093/Blog_BG_ylfoqa.png)`,
        }}
      >
        <div className="absolute inset-0 bg-black/30"></div>

        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4"
          >
            Our <span className="text-amber-400">Gallery</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg sm:text-xl md:text-2xl max-w-2xl mx-auto font-serif"
          >
            Capturing the vibrant moments of school life through our lens
          </motion.p>
        </div>
      </div>

      {/* Main Content Section - Split Layout */}
      <div className="bg-white">
        {/* Section with doodle background */}
        <div
          className="relative py-12 px-4 sm:px-6 lg:px-8"
          aria-label="Gallery Section"
        >
          <div
            className="absolute inset-0 bg-repeat opacity-5 -z-10"
            style={{
              backgroundImage: `url(${doodleBg})`,
              backgroundSize: "cover",
            }}
          ></div>

          <div className="max-w-7xl mx-auto">
            {/* Main Split Layout Container */}
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
              {/* Left Side - Text Content */}
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                className="lg:w-2/5"
              >
                <div className="sticky top-8">
                  {/* Updated heading with Caveat Brush font and gradient line */}
                  <h2 className="text-4xl md:text-5xl lg:text-6xl text-black mb-2 font-bold">
                    LIFE AT CAMPUS
                  </h2>

                  {/* Gradient line under heading */}
                  <div className="gradient-line mb-6"></div>

                  <div className="space-y-6 text-gray-700">
                    <p className="text-lg leading-relaxed text-justify">
                      St. Thomas Vidyalayam is a vibrant and joyful learning
                      environment where education goes beyond the classroom. The
                      school is always alive with celebrations, performances,
                      festivals, competitions, and meaningful experiences that
                      help students grow emotionally, academically, and
                      creatively. Each event, whether a cultural show, a
                      festival celebration, or a special program with esteemed
                      chief guests, becomes a cherished memory and a moment of
                      pride for our students. The gallery reflects these
                      unforgettable experiences — the laughter shared with
                      friends, the excitement of stage performances, the
                      dedication during practice sessions, and the applause that
                      follows every achievement. Students here learn to express
                      themselves, discover their talents, build confidence, and
                      broaden their understanding of the world while enjoying a
                      nurturing and supportive atmosphere. St. Thomas Vidyalayam
                      is not just a place to study; it is a colorful journey of
                      learning, friendship, joy, exploration, and preparation
                      for the future.
                    </p>
                  </div>
                </div>
              </motion.div>

              {/* Right Side - Gallery Grid */}
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="lg:w-3/5"
              >
                {/* SEAMLESS 4x4 Grid - Minimal gap */}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-0.1 sm:gap-0.1 -mx-0.">
                  {galleryItems.map((item) => (
                    <motion.div
                      key={item.id}
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.4, delay: item.id * 0.02 }}
                      className="relative group"
                    >
                      {/* Flip Card Container */}
                      <div className="relative w-full aspect-square cursor-pointer [perspective:1000px]">
                        {/* Flip Card Inner */}
                        <div className="relative w-full h-full transition-all duration-500 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
                          {/* Front of Card - Seamless */}
                          <div className="absolute inset-0 w-full h-full [backface-visibility:hidden] overflow-hidden">
                            <img
                              src={item.frontImage}
                              alt={`Gallery ${item.id} - Front`}
                              className="w-full h-full object-cover"
                              loading="lazy"
                            />
                          </div>

                          {/* Back of Card - Seamless */}
                          <div className="absolute inset-0 w-full h-full [transform:rotateY(180deg)] [backface-visibility:hidden] overflow-hidden">
                            <img
                              src={item.backImage}
                              alt={`Gallery ${item.id} - Back`}
                              className="w-full h-full object-cover"
                              loading="lazy"
                            />
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
